import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Eye, EyeOff, AlertCircle, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const ADMIN_PASSWORD = "diamond62";
const ADMIN_AUTH_KEY = "nsas_admin_auth";

export const AdminGate = ({ children }) => {
  // Skip the second password gate - user is already authenticated via main PasswordGate
  return children;
};

export default AdminGate;
